module.exports = __webpack_public_path__ + "img/icon.1e58ec35.png";